<template>
  <div>
    <div class="form-row div-valign" v-if="this.specificVo.beneGroup == 'MEA' && this.lgType == 5">
      <div class="form-group col-md-6">
        <label>บัญชีแสดงสัญญา</label><span class="required">*</span>
        <input 
          v-model="caNoExt" 
          name="caNoExt" 
          v-validate="{required:true,max:20}"
          :class="{'input': true, 'is-danger': errors.has('caNoExt') }"
          type="text" class="form-control" >
        <span v-show="errors.has('caNoExt')" class="help is-danger">กรุณากรอก บัญชีแสดงสัญญา</span>
      </div>
      <div class="form-group col-md-6">
        <label>เครื่องวัดไฟฟ้าเลขที่</label><span class="required">*</span>
        <input 
        v-model="meterNoExt" 
        name="meterNoExt" 
        v-validate="{required:true,max:20}"       
        :class="{'input': true, 'is-danger': errors.has('meterNoExt') }"
        type="text" class="form-control" >
        <span v-show="errors.has('meterNoExt')" class="help is-danger">กรุณากรอก เครื่องวัดไฟฟ้าเลขที่</span>
      </div>
    </div>
    <div class="form-row div-valign" v-if="this.specificVo.ctrNoFlag == 'Y'">
      <div class="form-group col-md-6">
        <label>{{ txtCtrNo }}</label><span class="required" v-if="this.isRequiredCtrNo">*</span>
        <input
          v-model="ctrNoExt"
          name="ctrNoExt"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredCtrNo }"
          :class="{ input: true, 'is-danger': errors.has('ctrNoExt') }"
          maxlength="50"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('ctrNoExt')" class="help is-danger">กรุณากรอก {{txtCtrNo}}</span>
      </div>
    </div>
    <div class="form-row div-valign" v-if="this.specificVo.ctrNameFlag == 'Y'">
      <div class="form-group col-md-6">
        <label>{{ txtCtrName }}</label>
        <span class="required" v-if="this.isRequiredCtrName">*</span>
        <input
          v-model="ctrNameExt"
          name="ctrNameExt"
          data-vv-as="ชื่อสัญญา"
          v-validate="{ required: this.isRequiredCtrName }"
          :class="{ input: true, 'is-danger': errors.has('ctrNameExt') }"
          maxlength="200"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('ctrNameExt')" class="help is-danger">กรุณากรอก {{txtCtrName}}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.ctrDateFlag == 'Y'">
      <div class="form-group col-md-6">
        <label
          >{{txtCtrDate}}<span class="required" v-if="this.isRequiredCtrDate"
            >*</span
          >
          <span class="text-white" v-if="this.txtCtrDate.length < 17">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </label>
        <date-picker
          v-model="ctrDateExt"
          name="ctrDateExt"
          ref="ctrDateExt"
          format="DD/MM/YYYY"
          v-validate="{ required: this.isRequiredCtrDate }"
          data-vv-as="ข้อมูล"
          lang="th"
          :class="{ input: true, 'is-danger': errors.has('ctrDateExt') }"
          placeholder
        ></date-picker>
        <span v-show="errors.has('ctrDateExt')" class="help is-danger">กรุณากรอก {{txtCtrDate}}</span>
      </div>
    </div>

    <div
      class="form-row div-valign"
      v-if="this.specificVo.beneRemarkFlag == 'Y'"
    >
      <div class="form-group col-md-12">
        <label>
          {{labelBeneRemark}}
        </label><span class="required" v-if="this.isRequiredBeneRemark">*</span>
        <input
          v-model="beneficiaryRemarkExt"
          name="beneficiaryRemarkExt"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredBeneRemark }"
          :class="{ input: true, 'is-danger': errors.has('beneficiaryRemarkExt') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('beneficiaryRemarkExt')" class="help is-danger">กรุณากรอก {{labelBeneRemark}}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.dealerCodeFlag == 'Y'">
      <div class="form-group col-md-6">
        <label> {{labelDealerCode}} </label
        ><span class="required" v-if="this.isRequiredDealerCode">*</span>
        <input
          v-model="dealerCodeExt"
          name="dealerCodeExt"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredDealerCode }"
          :class="{ input: true, 'is-danger': errors.has('dealerCodeExt') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('dealerCodeExt')" class="help is-danger">กรุณากรอก {{labelDealerCode}}</span>
      </div>
    </div>

    <div
      class="form-row div-valign"
      v-if="this.specificVo.ctrDatePEAFlag == 'Y'"
    >
      <div class="form-group col-md-6">
        <label>สัญญาลงวันที่</label
        ><span class="required" v-if="this.isRequiredCtrDatePEA">*</span>
        <date-picker
          v-model="ctrDatePEAExt"
          name="ctrDatePEAExt"
          ref="ctrDatePEAExt"
          format="DD/MM/YYYY"
          data-vv-as="สัญญาลงวันที่"
          v-validate="{ required: this.isRequiredCtrDatePEA }"
          lang="th"
          :class="{ input: true, 'is-danger': errors.has('ctrDatePEAExt') }"
          placeholder
        ></date-picker>
        <span v-show="errors.has('ctrDatePEAExt')" class="help is-danger">{{
          errors.first("ctrDatePEAExt")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.lgDescription3Flag == 'Y'">
      <div class="form-group col-md-6">
        <label>{{ labelLgDescription3 }}</label>
        <span class="required" v-if="this.isRequiredLgDescription3">*</span>
        <input
          v-model="lgDescription3Ext"
          name="lgDescription3Ext"
          data-vv-as="ชื่อสัญญาหลัก"
          v-validate="{ required: this.isRequiredLgDescription3 }"
          :class="{ input: true, 'is-danger': errors.has('lgDescription3Ext') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('lgDescription3Ext')" class="help is-danger">กรุณากรอก {{labelLgDescription3}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.projectIdFlag == 'Y'">
        <label style="display: contents;">{{ labelProjectId }}</label
        ><span class="required" v-if="this.isRequiredProjectId">*</span>
        <input
          v-model="projectIdExt"
          name="projectIdExt"
          data-vv-as="เลขที่โครงการ"
          v-validate="{ required: this.isRequiredProjectId }"
          :class="{ input: true, 'is-danger': errors.has('projectIdExt') }"
          maxlength="50"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('projectIdExt')" class="help is-danger">กรุณากรอก {{labelProjectId}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div
        class="form-group col-md-6"
        v-if="this.specificVo.projectNameFlag == 'Y'"
      >
        <label style="display: contents;">{{ labelProjectName }}</label
        ><span class="required" v-if="this.isRequiredProjectName">*</span>
        <input
          v-model="projectNameExt"
          name="projectNameExt"
          data-vv-as="ข้อมูล"
          v-validate="{ required: isRequiredProjectName }"
          :class="{ input: true, 'is-danger': errors.has('projectNameExt') }"
          maxlength="150"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('projectNameExt')" class="help is-danger">กรุณากรอก {{labelProjectName}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.productTypeFlag == 'Y'">
        <label style="display: contents;">{{ labelProductType }}</label
        ><span class="required" v-if="this.isRequiredProductType">*</span>
        <input
          v-model="productTypeExt"
          name="productTypeExt"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredProductType }"
          :class="{ input: true, 'is-danger': errors.has('productTypeExt') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('productTypeExt')" class="help is-danger">กรุณากรอก {{labelProductType}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.collectionPhaseFlag == 'Y'" >
        <label style="display: contents;">งวดเงินทั้งหมด(เริ่มต้น/สิ้นสุด)</label><span class="required" v-if="this.isRequiredCollectionPhase">*</span>
        <input
          v-model="collectionPhaseExt"
          name="collectionPhaseExt"
          data-vv-as="งวดเงินทั้งหมด(เริ่มต้น/สิ้นสุด)"
          v-validate="{ required: this.isRequiredCollectionPhase }"
          :class="{ input: true, 'is-danger': errors.has('collectionPhaseExt') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('collectionPhaseExt')" class="help is-danger">{{
          errors.first("collectionPhaseExt")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.projectBudgetAmtFlag == 'Y'">
        <label style="display: contents;">{{ labelProjectBudgetAmt }}</label
        ><span class="required" v-if="this.isRequiredProjectBudgetAmt">*</span>
        <vue-numeric
          v-model="projectBudgetAmtExt"
          name="projectBudgetAmtExt"
          v-bind:precision="2"
          data-vv-as="มูลค่าขั้นต่ำของคลื่นความถี่"
          v-validate="{ required: this.isRequiredProjectBudgetAmt }"
          @keypress="isNumber($event)"
          :class="{ input: true, 'is-danger': errors.has('projectBudgetAmtExt') }"
          class="form-control"
        ></vue-numeric>
        <span v-show="errors.has('projectBudgetAmtExt')" class="help is-danger">{{
          errors.first("projectBudgetAmtExt")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.seqNoFlag == 'Y'" >
        <label style="display: contents;">ลำดับผู้ยื่นคำขอตามคลื่นความถี่</label><span class="required" v-if="this.isRequiredSeqNo">*</span>
        <input
          v-model="seqNoExt"
          name="seqNoExt"
          data-vv-as="ลำดับผู้ยื่นคำขอตามคลื่นความถี่"
          v-validate="{ required: this.isRequiredSeqNo }"
          :class="{ input: true, 'is-danger': errors.has('seqNoExt') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('seqNoExt')" class="help is-danger">{{
          errors.first("seqNoExt")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.bidExpireDateFlag == 'Y'">
        <label>{{ labelBidExpireDate }}</label><span class="required" v-if="this.isRequiredBidExpireDate">*</span>
        <date-picker
          v-model="bidExpireDateExt"
          name="bidExpireDateExt"
          ref="bidExpireDateExt"
          format="DD/MM/YYYY"
          data-vv-as="วันที่สิ้นสุดการวางหลักประกัน"
          v-validate="{ required: this.isRequiredBidExpireDate }"
          lang="th"
          :class="{ input: true, 'is-danger': errors.has('bidExpireDateExt') }"
          placeholder
        ></date-picker>
        <span v-show="errors.has('bidExpireDateExt')" class="help is-danger">กรุณากรอก {{ labelBidExpireDate }}</span>
      </div>
    </div>

    <div class="form-row div-valign">  
      <div class="form-group col-md-12" v-if="this.specificVo.guaranteePriceAmtFlag=='Y'">
        <label>{{ labelGuaranteePriceAmt }}</label><span class="required" v-if="this.isRequiredGuaranteePriceAmt">*</span>
        <vue-numeric
          v-model="guaranteePriceAmtExt"
          name="guaranteePriceAmtExt"
          v-bind:precision="2"
          data-vv-as="จํานวนเงินในการวางประกัน"
          @keypress="isNumber($event)"
          v-validate="{ required: this.isRequiredGuaranteePriceAmt, min_value: 0.01}"
          :class="{'input': true, 'is-danger': errors.has('guaranteePriceAmtExt') }"
          class="form-control"
        ></vue-numeric>
        <span v-show="errors.has('guaranteePriceAmtExt')" class="help is-danger">{{ labelGuaranteePriceAmt }} ต้องมีค่ามากกว่า 0</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.percentageFlag == 'Y'">
        <label>{{labelPercentage}}</label
        ><span class="required" v-if="this.isRequiredPercentage">*</span>
        <vue-numeric
          v-model="percentageExt"
          name="percentageExt"
          separator=","
          v-bind:precision="2"
          data-vv-as="อัตราร้อยละ ในการวางหลักประกัน"
          @keypress="isNumber($event)"
          @blur="validPercent()"
          v-validate="{ required: this.isRequiredPercentage }"
          :class="{ input: true, 'is-danger': errors.has('percentageExt') }"
          class="form-control"
        ></vue-numeric>
        <span v-show="errors.has('percentageExt')" class="help is-danger">กรุณากรอก {{labelPercentage}}</span>
      </div>
    </div>

    <div class="form-row div-valign" >
      <div class="form-group col-md-6" v-if="this.specificVo.contractPeriodFlag == 'Y'">
        <label>งวดที่ประกันผลงาน</label
        ><span class="required" v-if="this.isRequiredContractPeriod">*</span>
        <input
          v-model="contractPeriod"
          name="contractPeriod"
          data-vv-as="งวดที่ประกันผลงาน"
          :class="{ input: true, 'is-danger': errors.has('contractPeriod') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('contractPeriod')" class="help is-danger">{{
          errors.first("contractPeriod")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.advancePaymentAmtFlag == 'Y'">
        <label>เงินค่าจ้างล่วงหน้า</label><span class="required" v-if="this.isRequiredAdvancePaymentAmtAmt">*</span>
        <vue-numeric
          v-model="advancePaymentAmtExt"
          name="advancePaymentAmtExt"
          v-bind:precision="2"
          data-vv-as="เงินค่าจ้างล่วงหน้า"
          @keypress="isNumber($event)"
          :class="{ input: true, 'is-danger': errors.has('advancePaymentAmtExt') }"
          class="form-control"
        ></vue-numeric>
        <span v-show="errors.has('advancePaymentAmtExt')" class="help is-danger">{{
          errors.first("advancePaymentAmtExt")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-12" v-if="this.specificVo.projectOwnerFlag == 'Y'">
        <label>{{labelProjectOwner}}</label><span class="required" v-if="this.isRequiredProjectOwner">*</span>
        <input
          v-model="projectOwnerExt"
          name="projectOwnerExt"    
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredProjectOwner }"
          :class="{ input: true, 'is-danger': errors.has('projectOwnerExt') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('projectOwnerExt')" class="help is-danger">กรุณากรอก {{labelProjectOwner}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-12" v-if="this.specificVo.manyCtrNoFlag=='Y'">
        <label>{{labelManyCtrNo}}</label><span class="required" v-if="this.isRequiredManyCtrNo">*</span>
        <input
          v-model="manyCtrNoExt"
          name="manyCtrNoExt"
          data-vv-as="เลขที่สัญญา ตั้งแต่ฉบับที่ 2"
          v-validate="{ required: this.isRequiredManyCtrNo}"
          :class="{'input': true, 'is-danger': errors.has('manyCtrNoExt') }"
          maxlength="400"
          type="text"
          class="form-control"
        >
        <span v-show="errors.has('manyCtrNoExt')" class="help is-danger">กรุณากรอก {{labelManyCtrNo}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-12" v-if="this.specificVo.manyCtrDateFlag=='Y'">
        <label>{{labelManyCtrDate}}</label><span class="required" v-if="this.isRequiredManyCtrDate">*</span>
        <input
          v-model="manyCtrDateExt"
          name="manyCtrDateExt"
          data-vv-as="สัญญาลงวันที่ ตั้งแต่ฉบับที่ 2: (yyyy-mm-dd,yyyy-mm-dd,....)"
          v-validate="{ required: this.isRequiredManyCtrDate}"
          :class="{'input': true, 'is-danger': errors.has('manyCtrDateExt') }"
          maxlength="400"
          type="text"
          class="form-control"
        >
        <span v-show="errors.has('manyCtrDateExt')" class="help is-danger">กรุณากรอก {{labelManyCtrDate}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-12" v-if="this.specificVo.manyCtrNameFlag == 'Y'">
        <label>{{labelManyCtrName}}</label><span class="required" v-if="this.isRequiredManyCtrName">*</span>
        <input
          v-model="manyCtrNameExt"
          name="manyCtrNameExt"
          data-vv-as="ชื่อสัญญาที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป"
          v-validate="{ required: this.isRequiredManyCtrName }"
          :class="{ input: true, 'is-danger': errors.has('manyCtrNoExt') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('manyCtrNameExt')" class="help is-danger">กรุณากรอก {{labelManyCtrName}}</span>
      </div>
    </div>

  </div>
    
  
</template>

<script>
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import moment from "moment";
import { apiClient } from "@/utils/apiClient";

export default {
  inject: ["$validator"],
  props: ["reqType", "appVo", "lgType", "lgFormNo", "beneGroup", "beneTaxId"],
  components: {
    DatePicker,
  },
  data() {
    return {
      caNoExt: "",
      meterNoExt: "",
      ctrNoExt: "",
      ctrNameExt: "",
      ctrDateExt: "",
      beneficiaryRemarkExt: "",
      specificVo: [],
      txtCtrNo: "เลขที่สัญญา",
      txtCtrName: "ชื่อสัญญา",
      txtCtrDate: "วันที่ลงสัญญา",
      isRequiredCtrNo: true,
      isRequiredCtrName: true,
      isRequiredCtrDate: true,
      isRequiredBeneRemark: true,
      isRequiredCtrDatePEA: false,
      isRequiredPercentage: false,
      isRequiredProjectName: false,
      isRequiredManyCtrNo: false,
      isRequiredManyCtrDate: false,
      isRequiredGuaranteePriceAmt: true,
      isRequiredContractPeriod: false,
      isRequiredProjectId: true,
      isRequiredProjectBudgetAmt: true,
      isRequiredSeqNo: true,
      isRequiredBidExpireDate: true,
      isRequiredProjectOwner: true,
      isRequiredAdvancePaymentAmtAmt: true,
      isRequiredCollectionPhase: true,
      isRequiredProductType: true,
      isRequiredDealerCode: true,
      isRequiredManyCtrName: false,
      isRequiredLgDescription3: false,
      ctrDatePEAExt: "",
      projectNameExt: "",
      percentageExt: "",
      labelProjectName: "ชื่อโครงการ (Project Name)",
      labelBeneRemark: "รายละเอียดโครงการ/รายละเอียดสัญญา",
      labelProjectId: "เลขที่โครงการ",
      labelGuaranteePriceAmt: "จํานวนเท่าในการวางประกัน",
      labelProjectOwner: "ชื่อหน่วยงาน",
      labelProductType: "ประเภทสินค้า",
      labelDealerCode: "รหัสของตัวแทนจำหน่าย",
      labelBidExpireDate: "วันที่สิ้นสุดการวางหลักประกัน",
      labelPercentage: "อัตราร้อยละ ในการวางหลักประกัน",
      labelProjectBudgetAmt: "มูลค่าขั้นต่ำของคลื่นความถี่",
      labelManyCtrNo: "เลขที่สัญญา ตั้งแต่ฉบับที่ 2: (xxx1,xxx2,....)",
      labelManyCtrDate: "สัญญาลงวันที่ ตั้งแต่ฉบับที่ 2: (yyyy-mm-dd,yyyy-mm-dd,....)",
      labelManyCtrName: "ชื่อสัญญาที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป",
      labelLgDescription3: "ชื่อสัญญาหลัก",
      manyCtrNoExt:"",
      manyCtrDateExt:"",
      guaranteePriceAmtExt:"",
      contractPeriod:"",
      projectIdExt:"",
      seqNoExt:"",
      projectBudgetAmtExt:"",
      bidExpireDateExt:"",
      projectOwnerExt:"",
      advancePaymentAmtExt:"",
      collectionPhaseExt:"",
      productTypeExt:"",
      dealerCodeExt:"",
      manyCtrNameExt:"",
      lgDescription3Ext:"",
    };
  },
  mounted() {
    this.$nextTick(() => {
      // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
      if (this.appVo) {
        this.ctrNoExt = this.appVo.ctrNo;
        this.ctrNameExt = this.appVo.ctrName;
        this.ctrDateExt = this.appVo.ctrDate ? moment(this.appVo.ctrDate, "DD/MM/YYYY"): '';
        this.beneficiaryRemarkExt = this.appVo.beneficiaryRemark;
        this.ctrDatePEAExt = this.ctrDate;
        if (this.beneTaxId === "0107536000269" || this.beneTaxId === "0105536080112") {
          //bangchak
          this.projectNameExt = this.appVo.projectName;
        }
        if(this.appVo.projectOwner === "" && this.beneGroup === "MU"){
          this.projectOwnerExt = "คณะแพทยศาสตร์โรงพยาบาลรามาธิบดี";
        }
      }

      this.lableProjectName = "ชื่อโครงการ (Project Name)";
      this.txtCtrNo = "เลขที่สัญญา";
      this.txtCtrDate= "วันที่ลงสัญญา";
      this.isRequiredCtrNo = true;
      this.isRequiredCtrName = true;
      this.isRequiredCtrDate = true;
      this.isRequiredCtrDatePEA = false;
      this.isRequiredPercentage = false;
      this.isRequiredProjectName = false;
      this.isRequiredGuaranteePriceAmt = true;

      if (
        this.beneGroup !== "" &&
        this.lgType !== "" &&
        this.lgFormNo !== "" &&
        this.beneTaxId !== ""
      ) {
        apiClient
          .get(
            "/api/home/getSpecificField/" +
              this.beneGroup +
              "/" +
              this.lgType +
              "/" +
              this.lgFormNo 
          )
          .then((resp) => {
            this.specificVo = resp.data;
            //for optional field BCI
            if (this.beneGroup === "BCP" || this.beneGroup === "BRIDGE") {
              if (this.beneTaxId === "0107536000269" || this.beneTaxId === "0105536080112") {
                //bangchak
                this.labelProjectName =
                  "วัตถุประสงค์การยื่นซองประกวดราคา/ชื่อโครงการ/วัตถุประสงค์การก่อหนี้";
                if (this.lgType == 3) {
                  this.isRequiredCtrName = true;
                  this.isRequiredCtrDate = true;
                  this.isRequiredProjectName = true;
                } else if (this.lgType == 7) {
                  this.isRequiredProjectName = true;
                  this.isRequiredCtrName = false;
                }
              } else {
                if (this.specificVo.ctrNameFlag === "Y") {
                  this.isRequiredCtrName = false;
                }
                if (this.specificVo.ctrDateFlag === "Y") {
                  this.isRequiredCtrDate = false;
                }
              }
            } else if (this.specificVo.beneGroup === "PEA") {
              this.txtCtrNo = "เลขที่สัญญา";
              if (
                this.specificVo.conitngentTypeId === "2" ||
                this.specificVo.conitngentTypeId === "9" ||
                (this.specificVo.conitngentTypeId === "3" && (this.lgFormNo ==="PEACABLE_PER_001_TH" || this.lgFormNo ==="PEACABLE_PER_002_TH" || this.lgFormNo ==="PEACABLE_PER_003_TH" || this.lgFormNo ==="PEACABLE_PER_004_TH"))
              ) {
                this.isRequiredCtrDatePEA = true;
              }
              if (
                this.specificVo.conitngentTypeId === "3" ||
                this.specificVo.conitngentTypeId === "7"
              ) {
                this.isRequiredProjectName = true;
              }
              if (
                this.specificVo.conitngentTypeId === "3" ||
                this.specificVo.conitngentTypeId === "7" ||
                this.specificVo.conitngentTypeId === "9"
              ) {
                this.isRequiredPercentage = true;
              }
            }else if (this.beneGroup === "AIS" || this.beneGroup === "SCCC"){
              if(this.lgType  === "1"){
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "เอกสารการประกวดราคาลงวันที่";
                this.labelProjectName = "วัตถุประสงค์การยื่นซองประกวดราคา/ชื่อโครงการ/วัตถุประสงค์การก่อหนี้";
                this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ชื่อโครงการ/วัตถุประสงค์การก่อหนี้";
                this.isRequiredCtrName = false;
                this.isRequiredProjectName = true;
                this.isRequiredBeneRemark = true;
                if(this.beneGroup === "SCCC"){
                  this.isRequiredCtrNo = false;
                  this.isRequiredCtrDate = false;
                }
              }else if(this.lgType === "9"){
                this.isRequiredCtrDate = false;
                if(this.specificVo.beneGroup === "SCCC"){
                  this.isRequiredCtrDate = true;
                }
              } 
            }else if(this.specificVo.beneGroup === "SHELL"){
                this.isRequiredCtrNo = false;
                this.isRequiredBeneRemark = false;
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ(Contract/ Project Description)";
            }else if(this.specificVo.beneGroup === "VNT"){
              if (this.specificVo.conitngentTypeId === "7") {
                  this.isRequiredCtrName = false;
                  this.isRequiredBeneRemark = false;
                  this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
              }
              if (this.specificVo.conitngentTypeId === "1") {
                  this.isRequiredCtrNo = false;
                  this.isRequiredCtrDate = false;
                  this.isRequiredBeneRemark = false;
                  this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                  this.txtCtrDate = "เอกสารการประกวดราคาลงวันที่";
                  this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ ชื่องานที่ประมูล/ ชื่อโครงการ";
              }
              if(this.specificVo.conitngentTypeId === "2" || this.specificVo.conitngentTypeId === "3" || this.specificVo.conitngentTypeId === "9"){
                  this.isRequiredCtrNo = false;
                  this.isRequiredCtrDate = false;
                  this.isRequiredCtrName = false;
                  this.isRequiredBeneRemark = false;
                  this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
              }
            }else if(this.specificVo.beneGroup === "CTL"){
              this.labelProjectOwner = "ชื่อย่อประเภทของธุรกิจ";
              if(this.lgFormNo === "CTL_GEN_PER_901_TH" || this.lgFormNo === "CTL_GEN_PER_902_TH"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredCtrDate = true;
                this.txtCtrNo = "เลขที่คำขอใช้วงเงินสินเชื่อ";
                this.txtCtrName = "ชื่อสัญญาซื้อขายผลิตภัณฑ์ปิโตรเลียม";
                this.txtCtrDate = "วันที่ลงนามคำขอใช้วงเงินสินเชื่อ";
                this.labelBeneRemark = "สัญญาการใช้บัตร Star Card";
              }else{
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.txtCtrNo = "เลขที่สิทธิในการค้าปลีกน้ำมันของเชฟรอน";
                this.txtCtrDate = "วันที่ลงนามสิทธิในการค้าปลีกน้ำมันของเชฟรอน";
              }
            }else if(this.specificVo.beneGroup === "NBTC"){
              this.isRequiredProjectName = true;
              this.isRequiredPercentage = true;
              this.labelProjectName = "ชื่อโครงการ";
              this.labelGuaranteePriceAmt = "จำนวนเงินของหลักประกัน";
              if(this.lgFormNo === "NBTC_BID_001_TH"){                
                this.txtCtrNo = "เลขที่เอกสาร";
                this.txtCtrDate = "วันที่ยื่นคำขอรับใบอนุญาต";
              }
              if(this.lgFormNo ==="CGD_ADV_001_TH" || this.lgFormNo ==="CGD_ADV_002_TH" || this.lgFormNo ==="CGD_RET_001_TH"){
                this.isRequiredProjectId = false;
                this.isRequiredProjectName = false;
                this.isRequiredGuaranteePriceAmt = false;
              }
            }else if(this.specificVo.beneGroup === "BGP"){
                this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
                if(this.specificVo.conitngentTypeId === "3"){
                  this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                  this.isRequiredCtrNo = false;
                  this.isRequiredBeneRemark = false;
                }
            }
            else if(this.specificVo.beneGroup === "CPN"){
              if (this.specificVo.conitngentTypeId === "1") {
                this.txtCtrNo = "เลขที่เอกสารประกวดราคา / เลขที่ TOR";
                this.txtCtrDate = "วันที่ TOR";
                this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ ชื่องานที่ประมูล/ ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "7"){
                this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
              }
            }
            else if(this.specificVo.beneGroup === "SKC"){
              if (this.specificVo.conitngentTypeId === "1") {
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ ชื่องานที่ประมูล/ ชื่อโครงการ";
              }else if (this.specificVo.conitngentTypeId === "3" || this.specificVo.conitngentTypeId === "9") {
                this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
              }
            }else if(this.specificVo.beneGroup === "PTTNGD"){
              this.labelProjectOwner = "ชื่อของบริษัทที่ต้องการขอออกหนังสือค้ำประกัน";
              if (this.specificVo.conitngentTypeId === "1") {
                this.txtCtrNo = "เลขที่เอกสารประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelProjectName = "ชื่อโครงการ";
                this.labelBidExpireDate = "วันที่สิ้นสุดการยื่นซอง";
                this.labelGuaranteePriceAmt = "จำนวนเงินของหลักประกัน";                
                this.isRequiredCtrDate = false;
                this.isRequiredProjectId = false;
                this.isRequiredProjectName = true;
              }else if(this.specificVo.conitngentTypeId === "3"){
                if(this.lgFormNo ==="NGD_PER_003_TH" || this.lgFormNo ==="NGD_PER_003_EN"){
                  this.txtCtrNo = "ฉบับเลขที่ของสัญญา/หนังสือสนอง/ใบสั่ง (ซื้อ/จ้าง/เช่า)";
                  this.txtCtrDate = "วันที่ทำสัญญา/หนังสือสนอง/ใบสั่ง (ซื้อ/จ้าง/เช่า)";
                  this.txtCtrName = "ชื่อของสัญญา/หนังสือสนอง/ใบสั่ง (ซื้อ/จ้าง/เช่า)";
                  this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ ชื่อโครงการ  / รายละเอียดวัตถุประสงค์การก่อหนี้";
                  this.isRequiredCtrDate = false;
                }else if(this.lgFormNo ==="NGD_PER_001_TH" || this.lgFormNo ==="NGD_PER_002_TH"){
                  this.txtCtrDate = "วันที่สัญญา";
                  this.labelProjectName = "ชื่อโครงการ";
                  this.labelGuaranteePriceAmt = "จำนวนเงินของหลักประกัน";  
                  this.labelPercentage = "หลักประกันคิดเป็นอัตราร้อยละ/อัตราร้อยละของเงินประกันผลงาน";
                  this.isRequiredCtrDate = false;
                  this.isRequiredProjectName = true;
                }
              }else if(this.specificVo.conitngentTypeId === "7"){
                this.txtCtrNo = "เลขที่สัญญาประธาน";
                this.txtCtrName = "ลักษณะของมูลหนี้";
                this.txtCtrDate = "วันที่ทำสัญญาประธาน";
                this.labelBeneRemark = "วัตถุประสงค์ในการก่อหนี้";
                this.isRequiredCtrDate = false;
              }else if(this.specificVo.conitngentTypeId === "9"){
                this.txtCtrNo = "ฉบับเลขที่ของสัญญา";
                this.txtCtrName = "ชื่อของสัญญา";
                this.labelProjectName = "ชื่อโครงการ";
                this.isRequiredCtrDate = false;
              }  
            }else if(this.specificVo.beneGroup === "ESSO"){
              this.labelProjectName = "ชื่อโครงการ";
              this.txtCtrDate = "สัญญาลงวันที่";
              
              if(this.lgFormNo ==="ESSO_PER_901_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = false;
              }else if(this.lgFormNo ==="ESSO_PER_901_EN"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = false;
              }else{
                this.txtCtrName = "รายละเอียดของมูลหนี้ที่ก่อ";
                this.labelBeneRemark = "วัตถุประสงค์การก่อหนี้";
              }
            }else if(this.specificVo.beneGroup === "SKL"){
              if(this.lgFormNo ==="BCI_BID_904_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา / ชื่องานที่ประมูล / ชื่อโครงการ";
              }else if(this.lgFormNo ==="BCI_MER_903_TH"){
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
              }else if(this.lgFormNo ==="BCI_ADV_902_TH" || this.lgFormNo ==="BCI_PER_911_TH" || this.lgFormNo ==="BCI_RET_908_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
              }else if(this.lgFormNo ==="BCI_RET_907_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
              }
            }else if(this.specificVo.beneGroup === "MEA"){
                this.txtCtrDate = "สัญญาลงวันที่";
                this.txtCtrName = "ชื่อผู้ใช้ไฟฟ้า";
                this.labelBeneRemark = "เลขที่อ้างอิง";
            }else if(this.specificVo.beneGroup === "DOHOME"){
                this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดโครงการ / รายละเอียดสัญญา";
                this.isRequiredCtrNo = false;
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                if(this.lgFormNo ==="BCI_MER_902_TH"){
                  this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
                }else if(this.lgFormNo ==="BCI_RET_905_TH" || this.lgFormNo ==="BCI_RET_906_TH"){
                  this.isRequiredBeneRemark = true;
                }
            }else if(this.specificVo.beneGroup === "MU"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredProjectOwner = true;
                this.isRequiredGuaranteePriceAmt = true;
                this.isRequiredContractPeriod = true;
                this.isRequiredProjectId = true;
                this.isRequiredProjectName = true;
                this.isRequiredProjectBudgetAmt = true;
                this.isRequiredPercentage = true;
                this.labelProjectName = "ชื่อโครงการ";
                this.labelProjectBudgetAmt = "วงเงินโครงการ";
                this.labelGuaranteePriceAmt = "จำนวนเงินของหลักประกัน";
                this.labelPercentage = "หลักประกันคิดเป็นอัตราร้อยละ/อัตราร้อยละของเงินประกัน";
                this.txtCtrDate = "สัญญาลงวันที่";
                if(this.lgFormNo ==="RAMAGOV_BID_001_TH"){
                  this.isRequiredCtrDate = false;
                  this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                  this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                  this.labelBidExpireDate = "วันที่สิ้นสุดการยื่นซอง";                
                }
            }else if(this.specificVo.beneGroup === "COMSEVEN"){
              if(this.specificVo.conitngentTypeId === "7"){
                this.isRequiredBeneRemark = false;
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
              }else if(this.specificVo.conitngentTypeId === "1"){
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = false;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelProjectName = "ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "3"){
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
              }else if(this.specificVo.conitngentTypeId === "9"){
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.txtCtrDate = "วันที่สัญญา";
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
                if(this.lgFormNo ==="BCI_RET_910_TH" || this.lgFormNo ==="BCI_RET_910_EN"){
                  this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                }
              }
            }else if(this.specificVo.beneGroup === "GCL"){
              if(this.specificVo.conitngentTypeId === "1"){
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = true;
                this.txtCtrDate = "วันที่ประกาศจัดซื้อจัดจ้าง";
                this.labelProjectName = "ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "2"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = true;
                this.txtCtrNo = "เลขที่ PO";
                this.txtCtrDate = "วันที่ในสัญญา / วันที่เริ่มโครงการ";
                this.labelBeneRemark = "รายละเอียดโครงการ / วัตถุประสงค์ค้ำประกัน";
              }else if(this.specificVo.conitngentTypeId === "3"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = true;
                this.txtCtrNo = "เลขที่สัญญา";
                this.txtCtrDate = "วันที่ในสัญญา / วันที่เริ่มโครงการ";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }else if(this.specificVo.conitngentTypeId === "7"){
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.txtCtrDate = "วันที่ในสัญญา / วันที่เริ่มโครงการ";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }else if(this.specificVo.conitngentTypeId === "9"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = true;
                this.txtCtrNo = "เลขที่ PO";
                this.txtCtrDate = "วันที่ในสัญญา / วันที่เริ่มโครงการ";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }
            }else if(this.specificVo.beneGroup === "EASTW"){
              if(this.specificVo.conitngentTypeId === "1"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = false;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelProjectName = "ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "2"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่สัญญา / เลขที่ PO";
                this.txtCtrName = "ชื่อสัญญา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }else if(this.specificVo.conitngentTypeId === "3" || this.specificVo.conitngentTypeId === "9"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่สัญญา";
                this.txtCtrName = "ชื่อสัญญา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }
            }else if(this.specificVo.beneGroup === "SSLC"){
              if(this.specificVo.conitngentTypeId === "1"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredProjectName = true;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelProjectName = "ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "2" || this.specificVo.conitngentTypeId === "3" || this.specificVo.conitngentTypeId === "9"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = true;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่สัญญา";
                this.txtCtrName = "ชื่อสัญญา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
                this.labelManyCtrNo = "เลขที่ของสัญญาที่ค้ำประกันเพิ่มเติม";
                this.labelManyCtrDate = "วันที่ของสัญญาที่ค้ำประกันเพิ่มเติม";
              }else if(this.specificVo.conitngentTypeId === "7"){
                this.isRequiredCtrName = true;
                this.isRequiredBeneRemark = true;
                this.isRequiredProjectOwner = true;
                this.txtCtrName = "ชื่อสัญญา";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
                this.labelManyCtrNo = "เลขที่ของสัญญาที่ค้ำประกันเพิ่มเติม";
                this.labelManyCtrDate = "วันที่ของสัญญาที่ค้ำประกันเพิ่มเติม";
              }
            }else if(this.specificVo.beneGroup === "SFL"){
              if(this.lgFormNo ==="SFL_GEN_PER_901_TH" || this.lgFormNo ==="SFL_GEN_PER_902_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredCtrName = false;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "ชื่อ และ/หรือ เลขที่สัญญา";
                this.txtCtrName = "ชื่อหลักฐานการซื้อขายผลิตภัณฑ์ปิโตรเลียม";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "สัญญาการใช้บัตร Star Card";
                this.labelManyCtrNo = "เลขที่สัญญาที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป";
                this.labelManyCtrDate = "วันที่ของสัญญาที่ค้ำประกันเพิ่มเติมกรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป";
                this.labelProjectOwner="ชื่อย่อประเภทของธุรกิจ";
              }else if(this.lgFormNo ==="SFL_DML_PER_901_TH" || this.lgFormNo ==="SFL_EQU_PER_901_TH"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่สัญญาให้สิทธิในการค้าปลีกน้ำมัน";
                this.txtCtrDate = "วันที่ลงนามสัญญาให้สิทธิในการค้าปลีกน้ำมัน";
                this.labelManyCtrNo = "เลขที่สัญญาให้สิทธิในการค้าปลีกน้ำมันที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป";
                this.labelManyCtrDate = "วันที่ลงนามสัญญาให้สิทธิในการค้าปลีกน้ำมันที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป";
                this.labelProjectOwner="ชื่อย่อประเภทของธุรกิจ";
              }
            }   
          })
          .catch((error) => {});
      }
    });
  },
  watch: {
    caNoExt() {
      this.emitChildExtToParent();
    },
    meterNoExt() {
      this.emitChildExtToParent();
    },
    ctrNoExt() {
      this.emitChildExtToParent();
    },
    ctrNameExt() {
      this.emitChildExtToParent();
    },
    ctrDateExt() {
      this.emitChildExtToParent();
    },
    beneficiaryRemarkExt() {
      this.emitChildExtToParent();
    },
    ctrDatePEAExt() {
      this.emitChildExtToParent();
    },
    projectNameExt() {
      this.emitChildExtToParent();
    },
    percentageExt() {
      this.emitChildExtToParent();
    },
    manyCtrNoExt() {
      this.emitChildExtToParent();
    },
    manyCtrDateExt() {
      this.emitChildExtToParent();
    },
    guaranteePriceAmtExt() {
      this.emitChildExtToParent();
    },
    contractPeriodExt() {
      this.emitChildExtToParent();
    },
    projectIdExt() {
      this.emitChildExtToParent();
    },
    seqNoExt() {
      this.emitChildExtToParent();
    },
    projectBudgetAmtExt() {
      this.emitChildExtToParent();
    },
    bidExpireDateExt() {
      this.emitChildExtToParent();
    },
    projectOwnerExt() {
      this.emitChildExtToParent();
    },
    advancePaymentAmtExt() {
      this.emitChildExtToParent();
    },
    collectionPhaseExt() {
      this.emitChildExtToParent();
    },
    productTypeExt() {
      this.emitChildExtToParent();
    },
    manyCtrNameExt() {
      this.emitChildExtToParent();
    },
    lgDescription3Ext() {
      this.emitChildExtToParent();
    },
  },
  methods: {
    emitChildExtToParent() {
      this.$emit("childExtToParent", {
        caNo: this.caNoExt,
        meterNo: this.meterNoExt,
        ctrNo: this.ctrNoExt,
        ctrName: this.ctrNameExt,
        ctrDate: this.ctrDateExt,
        beneficiaryRemark: this.beneficiaryRemarkExt,
        ctrDatePEA: this.ctrDatePEAExt,
        projectName: this.projectNameExt,
        percentage: this.percentageExt,
        manyCtrNo: this.manyCtrNoExt,
        manyCtrDate: this.manyCtrDateExt,
        guaranteePriceAmt: this.guaranteePriceAmtExt,
        contractPeriod: this.contractPeriod,
        projectId: this.projectIdExt,
        seqNo: this.seqNoExt,
        projectBudgetAmt: this.projectBudgetAmtExt,
        bidExpireDate: this.bidExpireDateExt,
        projectOwner: this.projectOwnerExt,
        advancePaymentAmt: this.advancePaymentAmtExt,
        collectionPhase: this.collectionPhaseExt,
        productType: this.productTypeExt,
        dealerCode: this.dealerCodeExt,
        manyCtrName: this.manyCtrNameExt,
        lgDescription3: this.lgDescription3Ext
      });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validPercent() {
      if (100 < this.percentageExt) {
        this.percentageExt = "100.00";
      }
    },
  },
};
</script>
<style>
.required {
  font-weight: bold;
  color: red;
  font-size: 1.5em;
}
</style>
